import { render, staticRenderFns } from "./TiktokCard.vue?vue&type=template&id=6875e6d0&scoped=true&"
import script from "./TiktokCard.vue?vue&type=script&lang=js&"
export * from "./TiktokCard.vue?vue&type=script&lang=js&"
import style0 from "./TiktokCard.vue?vue&type=style&index=0&id=6875e6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875e6d0",
  null
  
)

export default component.exports